import React from "react";
import AboutMe from "./AboutMe";
import Experience from "./Experience";
import Projects from "./Projects";
import Skills from "./Skills";
import Languages from "./Languages";
import Education from "./Education";
import Certificate from "./Certificates";
import FAQComponent from "./Faq";
import Topbar from "./TopBar";
import "../styles/home.css";

const Home = () => {
  const handleScrollTo = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      console.error(`Section with id "${id}" not found.`);
    }
  };

  return (
    <div className="home">
      <section id="top">
        <Topbar onScrollTo={handleScrollTo} />
      </section>
      <section id="about" className="responsive-section">
        <AboutMe />
      </section>
      <section id="experience" className="responsive-section">
        <Experience />
      </section>
      <section id="projects" className="responsive-section">
        <Projects />
      </section>
      <section id="skills" className="responsive-section">
        <Skills />
      </section>
      
      <section id="certificate" className="responsive-section">
        <Certificate />
      </section>
      <section id="education" className="responsive-section">
        <Education />
      </section>
      {/* <section id="events" className="responsive-section">
        <Events />
      </section> */}
      <section id="languages" className="responsive-section">
        <Languages />
      </section>
      {/* <section id="blogs" className="responsive-section">
        <Blogs />
      </section> */}
      
      <section id="faq" className="responsive-section">
        <FAQComponent />
      </section>
      {/* <section id="myai" className="responsive-section">
        <AIChat />
      </section> */}
      
    </div>
  );
};

export default Home;
